import Vue from 'vue';
import Locale from '@/models/Locale';
import store from '@/store'

// Get locales (with hot reload)
// Would be nice to iterate over locales with dynamically constructed strings, but it's a no-go with require
const enLocale: Locale = { code: "en", translations: require("./en.json")};
if ((module as any).hot) {
    (module as any).hot.accept(['./en.json'], () => {
        replaceLocale("en", require('./en.json'));
    })
} 

const fiLocale: Locale = { code: "fi", translations: require('./fi.json') };
if ((module as any).hot) {
    (module as any).hot.accept(['./fi.json'], () => {
        replaceLocale("fi", require('./fi.json'));
    })
}

const locales: Locale[] = [
    enLocale,
    fiLocale,
];

function replaceLocale(locale, translations){
    if ((store.state as any).app.translateMode){
        console.log("Translate mode is on, won't replace locale " + locale + " in the state");
        (Vue as any).i18n.replace(locale, translations);
    }
}

export default locales;
